import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { typographyTheme } from '~typography';
import formTheme from '../../styles/formTheme';
var FormInputAddOn = styled.div.withConfig({
  displayName: "FormInputAddon__FormInputAddOn",
  componentId: "sc-1gcy550-0"
})(["font-family:", ";color:", ";font-size:", ";", ";", ";opacity:0;position:absolute;top:", ";transition:all 0.3s;", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, function (_ref2) {
  var theme = _ref2.theme,
      skin = _ref2.skin;
  return _get(theme, "form.label." + skin + ".color", formTheme.form.label[skin].color);
}, rem(2), function (_ref3) {
  var type = _ref3.type;
  return type === 'prepend' && css(["left:", ";"], rem(12));
}, function (_ref4) {
  var type = _ref4.type;
  return type === 'append' && css(["right:", ";"], rem(12));
}, rem(24), function (_ref5) {
  var focused = _ref5.focused,
      filled = _ref5.filled;
  return (focused || filled) && css(["font-size:", ";opacity:1;"], function (_ref6) {
    var theme = _ref6.theme;
    return rem(_get(theme, 'form.input.fontSize', formTheme.form.input.fontSize));
  });
}, function (_ref7) {
  var disabledValue = _ref7.disabledValue,
      skin = _ref7.skin,
      theme = _ref7.theme;
  return disabledValue && css(["color:", ";"], _get(theme, "form.label." + skin + ".colorDisabled", formTheme.form.label[skin].colorDisabled));
});
export default FormInputAddOn;